export const environment = {
  production: true,
  apiUrl: 'https://api.cityspeak.in'
};
